const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "alr_token";

export class ApiError extends Error {
  constructor(message, status, detail) {
    super(message);
    this.status = status;
    this.detail = detail;
    this.suspension = detail && typeof detail === "object" && detail.reason === "suspended" ? detail : null;
  }
}

let suspensionHandler = null;
export const setSuspensionHandler = (fn) => { suspensionHandler = fn; };

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

const detailToMessage = (d, status) => {
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.message || `Request failed (${status})`;
};

export async function api(path, { method = "GET", body, auth = true } = {}) {
  const headers = { "Content-Type": "application/json" };
  const token = auth ? getToken() : null;
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${BASE}/api${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      detail = j.detail !== undefined ? j.detail : j;
    } catch {}
    const err = new ApiError(detailToMessage(detail, res.status), res.status, detail);
    if (err.suspension && suspensionHandler) suspensionHandler(err.suspension);
    throw err;
  }
  if (res.status === 204) return undefined;
  return res.json();
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${BASE}/api/files/upload`, { method: "POST", headers: { Authorization: `Bearer ${getToken()}` }, body: fd });
  const j = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(detailToMessage(j.detail, res.status), res.status, j.detail);
  return { ...j, url: `${BASE}${j.url}` };
}

export const fileToDataUrl = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(String(r.result || ""));
  r.onerror = () => reject(r.error);
  r.readAsDataURL(file);
});
